import { handleModalZIndexOnFullscreen } from './useFullscreenToggle';

export const handleRteOverlayClick = (editorRef, isPlugin = false, isEntryInModal = false) => {
  let classes = editorRef.current.classList;
  if (isPlugin) {
    //@ts-ignore
    const postRobot = window.postRobot;
    postRobot.sendToParent('goFullscreen', { open: !classes.contains('fullscreen'), isEntryInModal });
  }
  classes.toggle('fullscreen');
  
  // Handle modal z-index when in modal context
  if (isEntryInModal) {
    handleModalZIndexOnFullscreen(editorRef);
  }
}